import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

Vue.use(Router)
Vue.use(Meta)

export default new Router({
  routes: [
    { path: '/:id', redirect: '/' },
    { path: '/search-results/:keywords' }
  ]
})
